import React from 'react';
// import PropTypes from 'prop-types';

import {Box, Container, Grid, Stack, Typography, Link, Divider, IconButton} from 'views/components';

import {Instagram, LinkedIn} from 'views/icons';
import {Translate} from 'views/module';

const FooterSection = (props) => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{pt: {xs: 6, md: 10}, pb: 2}}>
      <Container maxWidth="lg">
        <Grid container spacing={{xs: 4, md: 8}}>
          {/* Brand + Social */}
          <Grid size={{xs: 12, md: 4}}>
            <Stack spacing={2}>
              <Typography variant="h5" sx={{fontWeight: 700, letterSpacing: 1}}>
                <Translate expression="caregiverProfile.Footer.Brand" />
              </Typography>

              <Stack direction="row" spacing={2}>
                <Link href="https://www.instagram.com/carequilt.ca/" target="_blank" rel="noopener" sx={{color: 'inherit'}}>
                  <IconButton
                    size="large"
                    sx={{'bgcolor': 'grey.900', 'color': 'common.white', '&:hover': {bgcolor: 'grey.800'}}}
                    aria-label="Instagram"
                  >
                    <Instagram />
                  </IconButton>
                </Link>
                <Link href="https://www.linkedin.com/company/carequilt" target="_blank" rel="noopener" sx={{color: 'inherit'}}>
                  <IconButton
                    size="large"
                    sx={{'bgcolor': 'grey.900', 'color': 'common.white', '&:hover': {bgcolor: 'grey.800'}}}
                    aria-label="LinkedIn"
                  >
                    <LinkedIn />
                  </IconButton>
                </Link>
              </Stack>
            </Stack>
          </Grid>

          {/* Quick Link */}
          <Grid size={{xs: 12, sm: 4, md: 2}}>
            <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>
              <Translate expression="caregiverProfile.Footer.QuickLinkTitle" />
            </Typography>
            <nav aria-label="Quick links">
              <Stack spacing={1.25}>
                <Link
                  underline="always"
                  href="https://caregiver.carequilt.ca/caregiver-application?_gl=1*xzax3z*_gcl_au*MTk5NTA5Nzc4OC4xNzU4NjM5OTAw"
                  sx={{color: 'black', textDecorationColor: 'black'}}
                >
                  <Translate expression="caregiverProfile.Footer.QuickLinkItemCareer" />
                </Link>
              </Stack>
            </nav>
          </Grid>

          {/* Legal */}
          <Grid size={{xs: 12, sm: 4, md: 3}}>
            <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>
              <Translate expression="caregiverProfile.Footer.LegalTitle" />
            </Typography>
            <nav aria-label="Legal">
              <Stack spacing={1.25}>
                <Link underline="always" href="https://carequilt.ca/Terms&Conditions" sx={{color: 'black', textDecorationColor: 'black'}}>
                  <Translate expression="caregiverProfile.Footer.LegalItemTerms" />
                </Link>
                <Link underline="always" href="https://carequilt.ca/privacy-policy" sx={{color: 'black', textDecorationColor: 'black'}}>
                  <Translate expression="caregiverProfile.Footer.LegalItemPrivacy" />
                </Link>
              </Stack>
            </nav>
          </Grid>

          {/* Follow Us */}
          <Grid size={{xs: 12, sm: 4, md: 3}}>
            <Typography variant="h6" sx={{mb: 2, fontWeight: 600}}>
              <Translate expression="caregiverProfile.Footer.FollowUsTitle" />
            </Typography>
            <nav aria-label="Social links">
              <Stack spacing={1.25}>
                <Link
                  underline="always"
                  href="https://www.instagram.com/carequilt.ca/"
                  target="_blank"
                  rel="noopener"
                  sx={{color: 'black', textDecorationColor: 'black'}}
                >
                  <Translate expression="caregiverProfile.Footer.FollowUsItemInstagram" />
                </Link>
                <Link
                  underline="always"
                  href="https://www.linkedin.com/company/carequilt"
                  target="_blank"
                  rel="noopener"
                  sx={{color: 'black', textDecorationColor: 'black'}}
                >
                  <Translate expression="caregiverProfile.Footer.FollowUsItemLinkedin" />
                </Link>
              </Stack>
            </nav>
          </Grid>
        </Grid>

        <Divider sx={{my: {xs: 4, md: 6}}} />

        {/* Bottom bar */}
        <Box sx={{textAlign: 'center', pb: 1}}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression="caregiverProfile.Footer.Copyright" substitute={{year}} />
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

FooterSection.propTypes = {

};

export default FooterSection;
